if (!customElements.get('cart-terms-checkbox')) {
  class CartTermsCheckbox extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('input[type="checkbox"]');
      this.scope = this.closest('[data-cart-terms-scope]') || this.parentElement;
      this.onChange = this.update.bind(this);
      this.onSubmitClick = this.blockCheckout.bind(this);

      this.checkbox.addEventListener('change', this.onChange);
      // Capture phase so the click is stopped before dynamic checkout buttons handle it.
      this.scope.addEventListener('click', this.onSubmitClick, true);
      this.update();
    }

    disconnectedCallback() {
      this.checkbox.removeEventListener('change', this.onChange);
      this.scope.removeEventListener('click', this.onSubmitClick, true);
    }

    get checkoutButtons() {
      return this.scope.querySelectorAll('button[name="checkout"]');
    }

    update() {
      const accepted = this.checkbox.checked;
      this.checkoutButtons.forEach((button) => (button.disabled = !accepted));
      this.scope.querySelectorAll('.additional-checkout-buttons').forEach((wrapper) => {
        wrapper.classList.toggle('cart-terms__blocked', !accepted);
        wrapper.setAttribute('aria-disabled', !accepted);
      });
    }

    blockCheckout(event) {
      if (this.checkbox.checked) return;
      if (!event.target.closest('button[name="checkout"], .additional-checkout-buttons')) return;

      event.preventDefault();
      event.stopPropagation();
      this.checkbox.focus();
    }
  }

  customElements.define('cart-terms-checkbox', CartTermsCheckbox);
}
